// TODO(CHANGE-68174): This folder is dead code if we're not supporting sharing bandits.
import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { ShareHeadlineContext } from './context';
import type { ShareHeadline } from './types';

type Props = ShareHeadline;

export const ShareHeadlineProvider: React.FC<PropsWithChildren<Props>> = ({
	children,
	description,
	title,
	sharer,
	previewLink,
}) => {
	const text = useMemo(
		() => ({
			description,
			title,
			sharer,
			previewLink,
		}),
		[description, title, sharer, previewLink],
	);

	return <ShareHeadlineContext.Provider value={text}>{children}</ShareHeadlineContext.Provider>;
};
